import { render, staticRenderFns } from "./DetalhesProcesso.vue?vue&type=template&id=7cce2ecc&scoped=true"
import script from "./DetalhesProcesso.vue?vue&type=script&lang=js"
export * from "./DetalhesProcesso.vue?vue&type=script&lang=js"
import style0 from "./DetalhesProcesso.vue?vue&type=style&index=0&id=7cce2ecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cce2ecc",
  null
  
)

export default component.exports